module.exports = __webpack_public_path__ + "static/img/500.0d0dd97f.png";